import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer, createContext, useMemo, } from 'react';
import { uiStateReducer, } from './actionsAndReducers';
import { UsageMode, } from '.';
// The initial state values for the global UI state
const initialModeUIState = {
    isLoading: false,
    drawerMenuOpened: false,
    currentLanguage: 'en',
    isEditingForm: false,
    usageMode: UsageMode.MANAGE_DATA,
    controlPanelComps: [],
    cache: {},
};
/**
 * An instance of the ModeUIContext. Any Component that are interested in the Mode UI context, can use React's useContext
 * to get a reference to this context like this
 *      const {state, dispatch} = React.useContext(modeUIContext);
 */
export const modeUIContext = createContext({
    state: initialModeUIState,
    dispatch: () => {
        return Promise.resolve();
    },
});
/**
 * Create a GENERIC Provider listen to the UI state's changes and update the children.
 */
export function ModeUIStateProvider({ children }) {
    const [state, dispatch] = useReducer(uiStateReducer, initialModeUIState);
    const contextValue = useMemo(() => {
        return {
            state, dispatch,
        };
    }, [state]);
    return (_jsx(modeUIContext.Provider, { value: contextValue, children: children }, void 0));
}
